// Stratos — Private Aviation
export const META = { brand: 'Stratos', tagline: 'Air Operations', tail: 'OE-STR', cert: 'Part 135 · ARG/US Platinum · IS-BAO Stage III' };

export const ROUTES = [
  { id: 'home', label: 'Operations' },
  { id: 'fleet', label: 'Fleet' },
  { id: 'safety', label: 'Safety File' },
  { id: 'quote', label: 'Request Quote' },
];

// "Live" departure board
export const DEPARTURES = [
  { tail: 'OE-STR', from: 'TEB', to: 'LFPB', dep: '14:50', eta: '02:35+1', type: 'Falcon 7X', status: 'BOARDING', pax: 8 },
  { tail: 'OE-IAN', from: 'EGGW', to: 'LIRA', dep: '15:20', eta: '17:35', type: 'Phenom 300', status: 'CLEARED', pax: 6 },
  { tail: 'OE-VOL', from: 'KMIA', to: 'EGLF', dep: '18:05', eta: '08:45+1', type: 'Global 6500', status: 'TAXI', pax: 10 },
  { tail: 'OE-NIM', from: 'OMDB', to: 'VHHH', dep: '21:40', eta: '11:25+1', type: 'Gulfstream G650', status: 'POSITIONING', pax: 12 },
  { tail: 'OE-ARI', from: 'LSGG', to: 'LFMN', dep: '07:15+1', eta: '08:25+1', type: 'Citation XLS+', status: 'SCHED', pax: 4 },
];

export const FLEET = [
  {
    cat: 'Light', model: 'Embraer Phenom 300E', tail: 'OE-IAN', range: '2,010 NM (3,724 km)', speed: 'M0.80', pax: 8, hourly: 'from £4,800 / hr',
    cabin: 'Stand-up cabin to 4 ft 11 in · single-club + 2 forward · refreshment galley',
    img: 'https://images.pexels.com/photos/2026324/pexels-photo-2026324.jpeg?auto=compress&cs=tinysrgb&w=1600',
  },
  {
    cat: 'Mid', model: 'Dassault Falcon 7X', tail: 'OE-STR', range: '5,950 NM (11,019 km)', speed: 'M0.90', pax: 12, hourly: 'from £8,400 / hr',
    cabin: 'Three-zone cabin · forward club, mid-conference, aft divan · full galley · two lavatories',
    img: 'https://images.pexels.com/photos/3850574/pexels-photo-3850574.jpeg?auto=compress&cs=tinysrgb&w=1600',
  },
  {
    cat: 'Heavy', model: 'Gulfstream G650ER', tail: 'OE-NIM', range: '7,500 NM (13,890 km)', speed: 'M0.925', pax: 14, hourly: 'from £12,400 / hr',
    cabin: 'Four-zone cabin · master en-suite · stand-up shower · 16 oversized windows',
    img: 'https://images.pexels.com/photos/879109/pexels-photo-879109.jpeg?auto=compress&cs=tinysrgb&w=1600',
  },
];

export const SAFETY_PILLARS = [
  { id: '01', t: 'Two captains, every leg', d: 'Both seats occupied by ATPL-rated captains with type-current sim checks within ninety days. We do not roster a first officer below ATPL.', n: 'STR-OPS-01' },
  { id: '02', t: 'Maintenance, in-house', d: 'EASA Part-145 station at Vienna-Schwechat. We do not subcontract A-checks. C-checks at the OEM only — Dassault, Gulfstream, Embraer.', n: 'STR-MX-02' },
  { id: '03', t: 'Eight-hour rule', d: 'No commercial flight begins less than eight hours after the captain last reported off-duty. We have refused departures rather than break this. Twice in 2024.', n: 'STR-FT-03' },
  { id: '04', t: 'Continuous audit', d: 'IS-BAO Stage III re-audited every 24 months. ARG/US Platinum since 2017. Wyvern Wingman since 2019. Independent audits, not self-attestation.', n: 'STR-AUD-04' },
];

export const KPI = [
  { v: '99.94%', l: 'Dispatch reliability, 12-mo' },
  { v: '0', l: 'Reportable incidents, 5-yr' },
  { v: '186', l: 'City pairs flown, 2025' },
  { v: '14 min', l: 'Median quote response' },
];
